import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";

const MAX_NOTE_LENGTH = 2000;

export default function PackageNotesModal({
  open,
  handleClose,
  initialNotes = "",
  onSave,
  saving = false,
  readOnly = false,
}) {
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (!open) return;
    setNotes(initialNotes != null ? String(initialNotes) : "");
  }, [open, initialNotes]);

  const handleSubmit = async () => {
    if (readOnly) {
      handleClose?.();
      return;
    }
    const trimmed = String(notes || "").trim();
    if (trimmed.length > MAX_NOTE_LENGTH) {
      toast.error(`Package notes must be at most ${MAX_NOTE_LENGTH} characters.`);
      return;
    }
    await onSave?.(trimmed);
  };

  return (
    <Modal open={open} onClose={saving ? undefined : handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 520,
          maxWidth: "calc(100vw - 32px)",
          background: "#fff",
          borderRadius: "12px",
          outline: "none",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            background: "#126ABC",
            padding: "16px 20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "16px" }}>
            Package notes
          </Typography>
          <IconButton onClick={handleClose} sx={{ color: "#fff", p: 0 }} disabled={saving}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ p: "24px" }}>
          <Typography sx={{ fontWeight: 500, mb: 1, fontSize: "14px", color: "#333" }}>
            Notes for invoice
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={4}
            maxRows={10}
            placeholder="Enter package notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            disabled={saving || readOnly}
            inputProps={{ maxLength: MAX_NOTE_LENGTH }}
            sx={{ mb: 1, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
          <Typography
            sx={{ fontSize: "12px", color: "#9C9C9C", textAlign: "right", mb: 2 }}
          >
            {String(notes || "").length}/{MAX_NOTE_LENGTH}
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5 }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              disabled={saving}
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                borderColor: "#126ABC",
                color: "#126ABC",
              }}
            >
              {readOnly ? "Close" : "Cancel"}
            </Button>
            {!readOnly && (
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={saving}
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  background: "#126ABC",
                  "&:hover": { background: "#0B2373" },
                }}
              >
                {saving ? "Saving…" : "Save notes"}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
